import { Company } from "./company.model"
import { Device } from "./device.model"

export class Container {
    public id?: number
    public name?:string
    public frm?: string
    public latitude?: string
    public longitude?: string
    public gpsFix?: string
    public gpsRepeat?: string
    public gpsSat?: string
    public altitude?: string
    public sValue?: number
    public bValue?: number
    public cValue?: number
    public cTemperature?: number
    public gsm?: string
    public pTime?: string
    public batCount?: string
    public gsmCount?: string
    public gpsCount?: string
    public reqCount?: string
    public perCount?: string
    public gCTime?: string
    public dUpdate?: boolean
    public dDate?: Date
    public ip?: string
    public rootType: string
    public streetDesc: string
    public street: string
    public neighbor: string
    public companyId?: number
    public deviceId?:string
    public containerType?: boolean
    public status?: boolean
    public simulation?: boolean
    public deadZone?:string
    public collectionTime?:number

    public company?:Company
    public device?:Device

}